import * as React from 'react';
export const tcfSvg = React.forwardRef(function tcfSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FF9028',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'm12.97 12.27.05-.06a4.57 4.57 0 0 1 3.38-1.83c1.34 0 1.61.6 1.82.9.33.01.6.01.63-.3h.2v-.6h8.63v3.64h-.56c0-.46-.28-1.21-.56-1.82-.27-.6-.9-1.21-1.39-1.21h-2.22v4.25h1.11c.44 0 .71-.3.84-.6.12-.32.27-.68.27-1.22h.56v4.86h-.56a4 4 0 0 0-.27-1.52c-.15-.23-.47-.62-.89-.62l-1.06.01v3.34c0 .58.13 1.05.28 1.22.15.17.59.3 1.11.3v.61h-4.45v-.6c.49 0 .7-.13.84-.3.13-.18.27-.66.27-1.23v-7.6c0-.59-.15-.75-.27-.9h-1.1v3.95h-.81c-.54-3.04-1.61-3.35-2.42-3.35-1.88 0-2.41 2.43-2.41 4.56 0 2.13.53 4.26 2.41 4.26 1.88 0 2.69-1.83 2.96-3.04h.53c-.27 3.04-2.41 4.25-3.76 4.25a3.57 3.57 0 0 1-2.95-1.82 7.1 7.1 0 0 1-1.07-3.65c0-.86.08-1.71.27-2.46-.03-.62-.15-1.36-.56-1.8-.58-.6-.82-.9-1.44-.9H9.8v8.5c0 .58.14 1.06.3 1.22.16.16.52.28 1.08.28l.06.63H6.05v-.6c.54 0 .99-.15 1.16-.31.16-.16.29-.64.29-1.22V11h-.58c-.6 0-.92.28-1.44.9-.53.64-.58 1.81-.58 2.44h-.58v-3.95h8.65v1.89z',
      }),
    ),
  );
});
tcfSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var tcf = {
  category: 'brand',
  colorable: false,
  name: 'tcf',
  svg: tcfSvg,
};
